/**
 * Gestion réactive et sécurisée de l'état global de l'application.
 *
 * Ce module contient :
 * - token : gestion sécurisée du token d’authentification (access & refresh) via un storage chiffré.
 * - isGlobalError / GlobalErrorMessage : gestion d’un message d’erreur global affiché à l’utilisateur.
 * - isGlobalSucess / GlobalSucessMessage : gestion d’un message global de succès.
 * - restaurantId : identifiant du restaurant actif dans l’application.
 * - visible : contrôle de la visibilité d'une modale ou d'un composant global.
 * - content : contenu dynamique affiché dans une modale (titre, infos client, items, etc.).
 * - globalHeaderTitleLayout : titre principal affiché dans le layout global.
 * - isPass / isPassword : états utilisés pour gérer l'affichage du mot de passe.
 * - isDashboard, isCommerce, isProdcut, isCategorie : états globalement persistés pour suivre la section active dans l'interface.
 * - titleSideBar : titre actif de la sidebar, stocké de manière sécurisée.
 * - typePass : type du champ mot de passe ("password" ou "text").
 *
 * Utilise ref() pour les données réactives
 * et useEncryptedStorage() pour les valeurs persistées et chiffrées dans le localStorage.
 */
import { useEncryptedStorage } from '@/composables/useEncryptedStorage';
import { EKeyOfLocalStorage } from '@/types/localstroage.types';
import { reactive, ref } from 'vue';

// Token migré vers cookie (plus sécurisé que localStorage)
export { token, rememberMe, clearToken } from '@/composables/useTokenCookie';

export const rolesArray = useEncryptedStorage(
  EKeyOfLocalStorage.ROLES_ARRAY,
  [],
);
export const isGlobalError = ref(false);
export const GlobalErrorMessage = ref(null);

export const formStepTwoCreateCome = reactive({
  nom: '',
  prenom: '',
  email: '',
  telephone: '',
  langue: 'Français',
  langueAutre: '',
});

export const isGlobalSucess = ref(false);
export const GlobalSucessMessage = ref(null);

export const restaurantId = ref('62655039-0c78-41dd-9f1a-ea33ab548062');
export const recommendationId = ref(null);
export const userCommerceId = ref<any>(null);
export const restauantIdVal = ref('62655039-0c78-41dd-9f1a-ea33ab548062');
export const visible = ref(false);

export const content = ref<null | {
  title?: string;
  clientInfo?: any;
  items?: any[] | any;
  isDeleted?: boolean;
  isAddedFromCommerce?: boolean;
  isUpdatedFromCommerce?: boolean;
  isAddedFromCategoy?: boolean;
  isAddedFromFile?: boolean;
  isUpdatedFromFile?: boolean;
  isUpdatedFromClient?: boolean;
  isAddedFromTaxe?: boolean;
  isAddedFromCurrency?: boolean;
  isUpdatedFromCurrency?: boolean;
  isReadMoreFrom?: boolean;
  isAddedFromProm?: boolean;
  isAddedFromCommerScheduled?: boolean;
  isAddedFromCommerseContact?: boolean;
  isAddedFromCreateUser?: boolean;
  isUpdatedFromUser?: boolean;
  isUpdatedFromUserPassword?: boolean;
  isAddedFromAssignment?: boolean;
  isAddedFromCommerceSlugs?: boolean;
  isUpdatedFromCommerceSlugs?: boolean;
  isAddeddFromCommerceImageOnboadronSlugs?: boolean;
  isUpdatedFromCommerceImageOnboadronSlugs?: boolean;
}>(null);

export const globalHeaderTitleLayout = ref('Informations supplémentaires');

export const isPass = ref(false);
export const isPassword = ref(false);

export const isDashboard = useEncryptedStorage(
  EKeyOfLocalStorage.isDashboard,
  true,
) as any;
export const isCommerce = useEncryptedStorage(
  EKeyOfLocalStorage.isCommerce,
  false,
);
export const isTables = useEncryptedStorage(EKeyOfLocalStorage.isTables, false);
export const isSchedules = useEncryptedStorage(
  EKeyOfLocalStorage.isSchedules,
  false,
);
export const isProgram = useEncryptedStorage(
  EKeyOfLocalStorage.isProgram,
  false,
);
export const isContact = useEncryptedStorage(
  EKeyOfLocalStorage.isContact,
  false,
);
export const isProduct = useEncryptedStorage(
  EKeyOfLocalStorage.isProduct,
  false,
);
export const isPromotion = useEncryptedStorage(
  EKeyOfLocalStorage.isPromotion,
  false,
);
export const isCategorie = useEncryptedStorage(
  EKeyOfLocalStorage.isCategorie,
  false,
);

export const isOnboardingImageCommerce = useEncryptedStorage(
  EKeyOfLocalStorage.isOnboardingImageCommerce,
  false,
);

export const isVersion = useEncryptedStorage(
  EKeyOfLocalStorage.isVersion,
  false,
);
export const isFile = useEncryptedStorage(EKeyOfLocalStorage.isFile, false);
export const isClient = useEncryptedStorage(EKeyOfLocalStorage.isClient, false);
export const isStaff = useEncryptedStorage(EKeyOfLocalStorage.isStaff, false);
export const isTax = useEncryptedStorage(EKeyOfLocalStorage.isTax, false);
export const isCountry = useEncryptedStorage(
  EKeyOfLocalStorage.isCountry,
  false,
);
export const isCurrency = useEncryptedStorage(
  EKeyOfLocalStorage.isCurrency,
  false,
);
export const isUser = useEncryptedStorage(EKeyOfLocalStorage.isUser, false);
export const isPermission = useEncryptedStorage(
  EKeyOfLocalStorage.isPermission,
  false,
);
export const isRole = useEncryptedStorage(EKeyOfLocalStorage.isRole, false);
export const titleSideBar = useEncryptedStorage(
  EKeyOfLocalStorage.title,
  'Accueil',
);

export const typePass = ref<'password' | 'text'>('password');

export const messageDelete = ref(
  'Attention : suppression définitive Cette action supprimera tous les détails de la commande, y compris tous les articles associés. Cette opération est irréversibleet les données ne pourront pas être récupérées. Êtes-vous sûr de vouloir supprimer cette commande ?',
);
export const animationCounter = ref(0);
export const searchQueryUserParams = ref();

export const titleRoute = ref<string>('Comptes clients');

export const titleValue = ref<string | null>(null);

export const isDeatilCommerce = ref(false);
export const shopId = ref('');
